<script setup>
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAccount } from 'dashboard/composables/useAccount';
import { useAlert } from 'dashboard/composables';
import SectionLayout from './SectionLayout.vue';
import Switch from 'next/switch/Switch.vue';

const { t } = useI18n();
const isEnabled = ref(false);

const { currentAccount, updateAccount } = useAccount();

watch(
  currentAccount,
  () => {
    const { conversation_tabs_enabled } = currentAccount.value?.settings || {};
    isEnabled.value = !!conversation_tabs_enabled;
  },
  { deep: true, immediate: true }
);

const updateAccountSettings = async settings => {
  try {
    await updateAccount(settings);
    useAlert(t('GENERAL_SETTINGS.FORM.CONVERSATION_TABS.API.SUCCESS'));
  } catch (error) {
    useAlert(t('GENERAL_SETTINGS.FORM.CONVERSATION_TABS.API.ERROR'));
  }
};

const toggleConversationTabs = async () => {
  return updateAccountSettings({
    conversation_tabs_enabled: isEnabled.value,
  });
};
</script>

<template>
  <SectionLayout
    :title="t('GENERAL_SETTINGS.FORM.CONVERSATION_TABS.TITLE')"
    :description="t('GENERAL_SETTINGS.FORM.CONVERSATION_TABS.NOTE')"
    with-border
  >
    <template #headerActions>
      <div class="flex justify-end">
        <Switch v-model="isEnabled" @change="toggleConversationTabs" />
      </div>
    </template>
  </SectionLayout>
</template>
